export default "__VITE_ASSET__BfihCgMD__"